// extracted by mini-css-extract-plugin
module.exports = {"app_pagination":"app_pagination_kn7C1"};